// Contact and profile links used across the React pages.
// Update them here once. (index.html and the structured data in it are static and edited separately.)
export const SITE_URL = "https://kiransable.com";
export const EMAIL = "kiranshinde0307@gmail.com";
export const GITHUB = "https://github.com/Kiran-Shinde";
export const LINKEDIN = "https://in.linkedin.com/in/kiran-shinde-518421298";
